import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    IconButton,
    TextField,
    Chip
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { Cancel } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import PatientSearchBar from '../PatientSearchBar';
import Button from '../../components/Button';
import ProviderRestrictedSearchBar from '../../components/ProviderRestrictedSearchBar';
import './styles.css';

function CreateGroupPatientModal(props) {
    const { enqueueSnackbar } = useSnackbar();
    const {
        viewOnly,
        patient = {},
        open,
        save,
        onClose,
        disableButton,
        classes: { modal, modalContent, selectInput },
    } = props;

    const [toProvider, setToProvider] = useState({});
    const [toPatientId, setToPatientId] = useState([]);
    const [validationErrors, setValidationErrors] = useState({});
    const [patients, setPatients] = React.useState([]);
    const [searchClear, setSearchClear] = React.useState(false);

    const validate = () => {
        let valid = true;
        const nextState = {};

        if (!toProvider.id) {
            nextState.toProvider = 'Required';
            valid = false;
        }
        if (!(toPatientId || patient.id)) {
            nextState.toPatientId = 'Required';
            valid = false;
        }

        setValidationErrors(nextState);
        return valid;
    };

    const onSave = async () => {
        save({
            providerId: toProvider.id,
            patientId: toPatientId
        })
    }


    const removePatient = (patient) => {
        setPatients((id) => id.filter((patients) => patients.id !== patient.id));
        setSearchClear(true)
    }
    const renderPatient = () =>
        patient.id ? (
            <TextField
                inputProps={{
                    disabled: true,
                }}
                label="Patient"
                variant="filled"
                fullWidth
                value={patient.name}
                className={selectInput}
            />
        ) : (
                <PatientSearchBar
                    label="Select Patient"
                    errorMessage={validationErrors.toPatientId}
                    searchClear={searchClear}
                    onSelect={patient => {
                        if (patient) {
                            if (patients.length < 5) {
                                setValidationErrors({ ...validationErrors, toPatientId: false });
                                setToPatientId((patients) => {
                                    return ([...patients, patient.id])
                                });
                                setPatients((patients) => {
                                    return ([...patients, patient])
                                })
                                setSearchClear(false)
                            } else  {
                                enqueueSnackbar('Should not add more than five patients', { preventDuplicate: true });
                            }
                        }
                    }}
                />
            );

    const renderToProvider = () =>
        viewOnly ? (
            <TextField
                inputProps={{
                    disabled: true,
                }}
                label="Select Restricted Provider"
                variant="filled"
                name="providerName"
                fullWidth
                value={toProvider.label}
                className={selectInput}
            />
        ) : (
                <ProviderRestrictedSearchBar
                    label="Select Restricted Provider"
                    name="toProvider"
                    placeholder="Search for a provider..."
                    errorMessage={validationErrors.toProvider}
                    onSelect={provider => {
                        if (provider) {
                            setValidationErrors({ ...validationErrors, toProvider: false });
                        }
                        setToProvider(provider || {});
                    }}
                    className={selectInput}
                />
            );

    return (
        <>
            <Dialog
                fullWidth
                open={open}
                onClose={onClose}
                classes={{ paper: modal }}
                maxWidth={'xl'}
            >
                <DialogTitle>
                    <Grid container alignItems="center">
                        <Grid item xs={11}>
                            <h2>Add Member To Provider Panel</h2>
                        </Grid>

                        <Grid item xs={1}>
                            <IconButton aria-label="Close" onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent classes={{ root: modalContent }}>
                    {renderToProvider()}
                    {renderPatient()}
                    <div className="singleselect">
                        {patients.length >= 1 && patients.map(patientId => (
                            <Chip
                                key={patientId}
                                onDelete={() => removePatient(patientId)}
                                clickable
                                deleteIcon={(<Cancel />)}
                                label={patientId.firstName}
                            />
                        ))}
                    </div>

                    <Grid item xs={12} lg={12}>
                        <Button className="custom-update-btn customSubmitBtn"
                            disabled={disableButton}
                            fullWidth
                            color="primary"
                            variant="contained"
                            onClick={onSave}
                            onClickValidation={toProvider.id && toPatientId && toPatientId.length >= 1 ? '' : validate}
                        >
                            Submit
              </Button>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
}

CreateGroupPatientModal.propTypes = {
    viewOnly: PropTypes.bool,
    note: PropTypes.object,
    patient: PropTypes.object,
    open: PropTypes.bool.isRequired,
    save: PropTypes.func,
    onClose: PropTypes.func.isRequired,
};

const styles = () => ({
    modal: {
        maxHeight: '700px',
        height: '410px'
    },
    singleselect: {
        marginBottom: '30px'
    },
    customSubmitBtn: {
        position: 'absolute',
        bottom: '0',
        left: '42%'
    },
    modalContent: {
        overflow: 'visible',
    },
    actions: {
        marginTop: '1em',
    },
    input: {
        margin: '0.5em 0',
    },
    selectInput: {
        marginTop: '0.5em',
        marginBottom: '1em',
    },
    previewImg: {
        maxWidth: 300,
        maxHeight: 300,
    }
});

export default withStyles(styles)(CreateGroupPatientModal);
